import FiveNavPic from './fiveNavPic';
import FourNavPic from './fourNavPic';
import ThreeNavPic from './threeNavPic';

export { FiveNavPic, FourNavPic, ThreeNavPic };
